export const loadDocumentEditor = () => import("./DocumentEditorContent");

/** A failed speculative download must not prevent a later editor load from retrying. */
export async function preloadDocumentEditor() {
  await loadDocumentEditor().catch(() => undefined);
}
